import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { isRead?: boolean }) => ({
    card: {
      padding: 16,
      backgroundColor: props.isRead
        ? token.colorWhite
        : `${token.primary.primary3}1a`,
      border: `1px solid ${token.colorSplit}`,
      borderRadius: token.borderRadius,
      cursor: 'pointer'
    },
    expandIcon: {
      marginTop: 35
    },
    viewDetails: {
      padding: 0,
      margin: 0,
      width: 'fit-content'
    }
  })
)
